<template>
  <div>
    <div class="recruit-detail">
      <div class="content-left">
        <div class="content-left-btn">
          <h3>{{detail.title}}</h3>
        </div>
        <img :src="detail.img" />
      </div>
      <div class="content-right">
        <div>
          <h4>职位描述：</h4>
          <div v-for="(message, index) in detail.children" :key="index">
            <span v-for="(name, index) in message" :key="index">{{name}}</span>
          </div>
        </div>
        <div v-for="(item, index) in detail.detail" :key="index">
          <h4>{{item.subTitle}}</h4>
          <div v-for="(txt, idx) in item.subTxt" :key="idx">
            {{txt}}
          </div>
        </div>
        <a :href="'mailto:'+detail.email">
        <div class="button">
          上传简历</div></a>
      </div>
    </div>
    <Footer /> 
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'RecruitDetail',
  components: {Footer},
  data () {
    return {
      store: this.$store.state,
      detail: []
    }
  },
  mounted() {
    this.detail = this.store.recruit[this.$route.params.id];
  }
}
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .recruit-detail {
    width: 80%;
    margin: 120px auto 100px auto;
    padding: 40px 80px 30px 80px;
    border: 1px solid #ddd;
    .content-left {
      float: left;
      width: 330px;
      margin-right: 80px;
    }
    .content-right {
      float: left;
      width: calc(100% - 410px);
    }
  }
}
@media (max-width: 997px) {
  .recruit-detail {
    margin-top: 60px;
    padding: 30px;
  }
}
.recruit-detail {
  background: #f8f8f8;
  overflow: hidden;
  zoom: 1;
  .content-left {
    .content-left-btn {
      border: 1px solid #000;
      padding: 10px 18px;
      text-align: center;
      display: inline-block;
      margin-bottom: 40px;
      h3 {
        margin: 0;
        font-size: 24px;
        font-weight: 500px;
        font-weight: normal;
      }
    }
    img {
      width: 100%;
    }
  }
  .content-right {
    div {
      color: #666;
      font-size: 16px;
      margin: 0;
      line-height: 28px;
    }
    h4 {
      margin: 10px 0 15px 0;
      font-size: 18px;
      color: #2c3e50;
    }
    span {
      margin-right: 15px;
      font-size: 16px;
      white-space: normal;
      display: inline-block;
    }
    .button {
      margin: 30px 0;
      background-color: #4597dc;
      border-color: #348ede;
      height: 45px;
      line-height: 45px;
      font-size: 18px;
      border-radius: 6px;
      color: #fff;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      width: 180px;
    }
  }
}
</style>
